export enum ProgressStatusEnum {
  notStarted = 'notStarted',
  inProgress = 'inProgress',
  completed = 'completed',
}
